export function get<T>(key: string, def: T | undefined = undefined): T | undefined {
  if (has(key)) {
    try {
      const item = localStorage.getItem(key)
      return item ? (JSON.parse(item) as T) : def
    } catch (err) {
      console.error(err)
      return def
    }
  }

  return def
}

export function set<T>(key: string, value: T): void {
  try {
    if (has(key)) {
      remove(key)
    }
    localStorage.setItem(key, JSON.stringify(value))
  } catch (err) {
    console.error(err)
  }
}

function has(key: string): boolean {
  return localStorage.getItem(key) !== null
}

function remove(key: string): void {
  localStorage.removeItem(key)
}
